import { Box, BoxProps, Image, ImageProps } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useAppSelector } from "store";
import { useLazyGetMovieDetailQuery } from "@store/services/movie";

export interface MovieBannerComponent1Props {
  containerProps?: BoxProps;
  imageProps?: ImageProps;
}

export function MovieBannerComponent1({
  containerProps,
  imageProps,
}: MovieBannerComponent1Props) {
  const router = useRouter();
  const movieIdx = router?.query?.movieIdx;
  const { company_idx } = useAppSelector((state) => state.config);

  const [getMovieDetail, { data: movieDetailRes }] =
    useLazyGetMovieDetailQuery({});
  const movie = movieDetailRes?.data;

  useEffect(() => {
    if (movieIdx) {
      getMovieDetail({ idx: movieIdx, company_idx });
    }
  }, [movieIdx, company_idx, getMovieDetail]);

  if (!movie?.banner) return null;

  return (
    <Box w="100%" overflow="hidden" {...containerProps}>
      <Image
        src={movie.banner}
        alt={movie.name}
        w="100%"
        display="block"
        {...imageProps}
      />
    </Box>
  );
}

export default MovieBannerComponent1;
